import React from "react";
import { Modal } from "react-bootstrap";
import "../../../assets/css/dashboard.css";
import Report from "../forms/Add_Report"

const AddReport = (props) => {
  return (
    <div>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="text-grey text-center">Add a Report</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Report/>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AddReport;
